/**
 * Where the PERSONAL AIRCRAFT turntable is looking from — *"the arrow keys on
 * the bottom left of the screen allow you to change the view of your aircraft.
 * You can zoom the camera in/out and rotate it left/right"* (manual, "Personal
 * Aircraft").
 *
 * Kept apart from `aircraft-preview.ts` because the pose is *model* state that
 * `shell/model/career-model.ts` owns and tests without a GPU, while the preview
 * itself pulls in three.js. Same split the rest of the shell makes.
 */

/** Camera distance as a multiple of the model's radius, nearest first. */
export const ZOOM_STEPS: readonly number[] = [1.9, 2.5, 3.2, 4.2];

/** Where the ladder starts — one notch out from closest, so both arrows do something. */
export const DEFAULT_ZOOM = 1;

/** Degrees per press of the rotate arrows. */
export const YAW_STEP_DEG = 15;

export interface PreviewPose {
  readonly yawDeg: number;
  /** Index into `ZOOM_STEPS`, always within range once through `clampZoom`. */
  readonly zoom: number;
}

/** Three-quarter view, as an aircraft is shown off. */
export const INITIAL_POSE: PreviewPose = { yawDeg: 30, zoom: DEFAULT_ZOOM };

export function clampZoom(zoom: number): number {
  return Math.max(0, Math.min(ZOOM_STEPS.length - 1, zoom));
}

/** The distance the camera sits at for a model of `radius`. */
export function zoomDistance(pose: PreviewPose, radius: number): number {
  return radius * (ZOOM_STEPS[clampZoom(pose.zoom)] ?? ZOOM_STEPS[DEFAULT_ZOOM] ?? 2.5);
}
